import regex from 'services/regex';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const asyncValidate = (values) => {
    return sleep(0)
        .then(() => {
            let _errors = {};
            let required = [
                'dateFrom',
                'dateTo',
                'positions',
            ];

            required.map((r) => {
                if (app._.isEmpty(values[r])) {
                    _errors[r] = app.translate('main.This field is required');
                }
            });

            if (!app._.isEmpty(_errors)) {
                throw _errors;
            } else {
                return Promise.resolve('Sign up is broken now!');
            }
        });
};

export default asyncValidate;
